"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ifequal = void 0;
const isNumber_1 = __importDefault(require("lodash/isNumber"));
function ifequal(data, comparison, options) {
    if (data && comparison) {
        if ((0, isNumber_1.default)(data)) {
            data = data.toString();
        }
        if ((0, isNumber_1.default)(comparison)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            comparison = comparison.toString();
        }
        if (data.toLowerCase() === comparison.toLowerCase()) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return options.fn(this);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return options.inverse(this);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return options.inverse(this);
}
exports.ifequal = ifequal;
